import "core-js/modules/es6.function.name";
var render = function render() {
  var _vm$userInfo, _vm$userInfo$erpInfoR;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "header-wrapper"
  }, [_c("div", {
    staticClass: "inner"
  }, [_c("img", {
    staticClass: "logo",
    attrs: {
      src: require("@/assets/common/header/logo.png"),
      alt: "logo"
    },
    on: {
      click: _vm.goHome
    }
  }), _vm._v(" "), !_vm.userInfo ? _c("div", {
    staticClass: "login-wrapper"
  }, [_c("div", {
    staticClass: "button",
    on: {
      click: _vm.login
    }
  }, [_vm._v("登录")])]) : _c("div", {
    staticClass: "login-wrapper"
  }, [_c("el-dropdown", {
    attrs: {
      trigger: "click"
    },
    on: {
      command: _vm.handleCommand
    }
  }, [_c("span", {
    staticClass: "el-dropdown-link name"
  }, [_c("img", {
    staticClass: "company",
    attrs: {
      src: require("@/assets/login/icon-company.png"),
      alt: ""
    }
  }), _vm._v("\n          " + _vm._s(_vm.userName)), _c("i", {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c("el-dropdown-menu", {
    staticClass: "header-new-drop",
    attrs: {
      slot: "dropdown"
    },
    slot: "dropdown"
  }, [_c("div", {
    staticClass: "info"
  }, [_c("div", {
    directives: [{
      name: "RelevanceCompany",
      rawName: "v-RelevanceCompany",
      value: "切换企业",
      expression: "'切换企业'"
    }],
    staticClass: "current"
  }, [_vm._v("\n              当前企业\n              "), _c("img", {
    staticClass: "toggle",
    attrs: {
      src: require("@/assets/login/icon-toggle.png"),
      alt: ""
    }
  }), _vm._v(" "), _c("span", {
    staticClass: "toggle_txt"
  }, [_vm._v("切换企业")])]), _vm._v(" "), _c("div", {
    staticClass: "company_name"
  }, [_vm._v("\n              " + _vm._s(((_vm$userInfo = _vm.userInfo) === null || _vm$userInfo === void 0 ? void 0 : (_vm$userInfo$erpInfoR = _vm$userInfo.erpInfoRespVO) === null || _vm$userInfo$erpInfoR === void 0 ? void 0 : _vm$userInfo$erpInfoR.name) || "暂未关联企业") + "\n            ")])]), _vm._v(" "), _c("el-dropdown-item", {
    staticClass: "item",
    attrs: {
      command: "updatePassword"
    }
  }, [_c("img", {
    staticClass: "icon",
    attrs: {
      src: require("@/assets/login/icon-password.png"),
      alt: ""
    }
  }), _vm._v(" "), _c("span", [_vm._v("修改密码")])]), _vm._v(" "), _c("el-dropdown-item", {
    staticClass: "item",
    staticStyle: {
      "border-top": "1px solid #f3f5f8"
    },
    attrs: {
      command: "logout"
    }
  }, [_c("img", {
    staticClass: "icon",
    attrs: {
      src: require("@/assets/login/icon-logout.png"),
      alt: ""
    }
  }), _vm._v(" "), _c("span", [_vm._v("退出登录")])])], 1)], 1)], 1)])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };